import { createI18n } from 'vue-i18n'
import type { SiteLocale } from '../types'

const messages = {
  'zh-CN': {
    nav: {
      product: '产品',
      docs: '文档',
      changelog: '更新日志',
      download: '下载',
      openApp: '打开应用',
    },
    common: {
      explore: '继续探索',
      learnMore: '了解详情',
      download: '下载 Motexa Ride',
      stable: '稳定版',
      beta: '测试版',
      soon: '即将发布',
      back: '返回',
      language: '语言',
    },
    footer: {
      line: '为电动两轮车而生的清晰工具。',
      copyright: '© 2026 Motexa Ride',
      privacy: '隐私政策',
      about: '关于我们',
    },
  },
  'en-US': {
    nav: {
      product: 'Product',
      docs: 'Docs',
      changelog: 'Changelog',
      download: 'Download',
      openApp: 'Open app',
    },
    common: {
      explore: 'Keep exploring',
      learnMore: 'Learn more',
      download: 'Download Motexa Ride',
      stable: 'Stable',
      beta: 'Test build',
      soon: 'Coming soon',
      back: 'Back',
      language: 'Language',
    },
    footer: {
      line: 'A clearer tool for electric two-wheelers.',
      copyright: '© 2026 Motexa Ride',
      privacy: 'Privacy',
      about: 'About',
    },
  },
} satisfies Record<SiteLocale, Record<string, unknown>>

export const i18n = createI18n({
  legacy: false,
  locale: 'zh-CN' satisfies SiteLocale,
  fallbackLocale: 'en-US',
  messages,
})
